module.exports = __webpack_public_path__ + "img/platform_target.55af616e.png";